import { render, staticRenderFns } from "./stationList.vue?vue&type=template&id=52b8d155"
import script from "./stationList.vue?vue&type=script&lang=js"
export * from "./stationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports